export class ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        this.product_json = product_json;
        this.product_id = this.product_json.id;
        this.section_id = section_id;
        this.enable_history = enable_history;
        this.stock_rules = {};
        this.master_select = null;
        this.product_form = null;
        this.quantity_selector = null;
        this.master_select_prefix = 'product-id';
        this.radio = '.option-radios-wrapper input[type=radio]';
        this.currentVariant = null;
        this.form = `form[action='${window.routes.cart_add_url}']`;

        this.init();
    }

    init() {
        this.master_select = document.querySelector('#' + this.master_select_prefix + '-' + this.section_id + '-' + this.product_id);
        this.product_form = this.master_select.closest(this.form);
        this.quantity_selector = this.product_form.querySelector('[quantity-select]');
        this.subtotal_el = this.product_form.querySelector('[product-sub-total]');
        this.maxtotal_el = this.product_form.querySelector('[product-max-total]');
        this.savingtotal_el = this.product_form.querySelector('[product-saving-total]');
        this.add_to_cart = this.product_form.querySelector('[add-to-cart]');
        this.add_to_cart_label = this.product_form.querySelector('[add-to-cart-label]');
        this.add_to_cart_price = this.product_form.querySelector('[add-to-cart-price]');

        this.mobile_subtotal_el = this.product_form.querySelector('[mobile-product-sub-total]');
        this.mobile_add_to_cart = this.product_form.querySelector('[mobile-add-to-cart]');
        this.mobile_add_to_cart_label = this.product_form.querySelector('[mobile-add-to-cart-label]');
        this.mobile_add_to_cart_price = this.product_form.querySelector('[mobile-add-to-cart-price]');

        this.gallery_slides = document.querySelectorAll("[main-gallery] .main-swiper-slide");
        this.text_add_to_cart = this.product_form.dataset.addToCart;
        this.text_sold_out = this.product_form.dataset.soldOut;
        this.text_unavailable = this.product_form.dataset.unavailable;
        this.money_format = this.product_form.dataset.moneyFormat;

        this.stockRules();
        this.shopifyOptionSelect();
        this.radiosOnChange();
        this.setupBlackFridayListener();

        this.setupAddOnsListener();

        this.addOnPrice = 0;
        this.addOnSelected = null;
    }

    setAddOns(variant) {
        const addOnWrapper = this.product_form.querySelector("[product-add-ons]");
        if (!addOnWrapper) {    
            return;
        }
        const addOns = addOnWrapper.querySelectorAll("[data-variant-id]");
        if (addOns.length === 0) {
            return;
        }
        addOns.forEach((addOn) => {
            const variantId = addOn.dataset.variantId;
            if (variantId === variant.id.toString()) {
                addOn.style.display = 'block';
            } else {
                addOn.style.display = 'none';
            }
        });
    }

    setupAddOnsListener() {
        const addOnWrapper = this.product_form.querySelector("[product-add-ons]");
        if (!addOnWrapper) {    
            return;
        }

       const addOns = addOnWrapper.querySelectorAll("input[type='radio']");

        if (addOns.length === 0) {
            return;
        }

        addOns.forEach((addOn) => {   
            addOn.addEventListener('change', () => {
                this.addOnPrice = addOn.dataset.price;
                this.addOnSelected = addOn.value;

                this.setVariantPrice(this.currentVariant);
            });
        });
    }

    setupBlackFridayListener() {
        window.addEventListener('cart_changed', (e) => {
            if (!this.currentVariant) return;
                        
            fetch(window.Shopify.routes.root + `products/${this.product_json.handle}?section_id=fs-black-friday-block&variant=${this.currentVariant.id}`)
                .then(response => response.text())
                .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const blackFridayBlock = htmlDocument.documentElement.querySelector("[black-friday-block]");
                    if (blackFridayBlock) {
                        const blackFridayBlockEl = this.product_form.querySelector("[black-friday-block]");

                        if (blackFridayBlockEl) {
                            blackFridayBlockEl.innerHTML = blackFridayBlock.innerHTML;
                            const cart_total = blackFridayBlockEl.querySelector("[data-cart-total]").dataset.cartTotal;
                            this.setVariantPrice(this.currentVariant, cart_total);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        });
    }

    stockRules() {
        const select_options = this.master_select.querySelectorAll('option');
        if (select_options.length === 0) {
            console.error("Select options not found.");
            return;
        }
        select_options.forEach((option) => {
            if (option.dataset.inventoryManagement === "shopify" && option.dataset.inventoryPolicy === "deny") {
                this.stock_rules[option.value] = option.dataset.inventoryQuantity;
            } else {
                this.stock_rules[option.value] = Number.MAX_SAFE_INTEGER;
            }
        });
    }

    setVariantPrice(variant) {
        if (!this.subtotal_el) {
            return;
        }

        const money_format = this.subtotal_el.dataset.moneyFormat;
        this.subtotal_el.setAttribute("data-variant-price", variant.price);

        if (this.product_form.querySelector('[black-friday-block]')) {
            // console.log("setVariantPrice", this.product_form.querySelector('[black-friday-block]'));
            const block = this.product_form.querySelector('[black-friday-block]');
            const activeBlock = block.querySelector('[variant-id="' + variant.id + '"]');

            if (!activeBlock) {
                this.subtotal_el.innerHTML = Shopify.formatMoney(variant.price, money_format);
                return;
            }

            const twenty_off_variant_price = activeBlock.dataset.twentyOffProductPrice;
            const thirty_off_variant_price = activeBlock.dataset.thirtyOffProductPrice;

            if (!twenty_off_variant_price || !thirty_off_variant_price) {
                this.subtotal_el.innerHTML = Shopify.formatMoney(variant.price, money_format);
                return;
            }

            let price = twenty_off_variant_price;
            if (block.dataset.thirtyOffOveride === "true") {
                price = thirty_off_variant_price;
            }


            this.subtotal_el.innerHTML = `<span class="compare">${Shopify.formatMoney(variant.price, money_format)}</span> ${Shopify.formatMoney(price, money_format)}`;
        } else {
            if (this.addOnPrice !== null) {
                let new_price = variant.price + parseInt(this.addOnPrice);
                this.subtotal_el.innerHTML = Shopify.formatMoney(new_price, money_format);
            } else {
                this.subtotal_el.innerHTML = Shopify.formatMoney(variant.price, money_format);
            }
            
        }

        if (!this.mobile_subtotal_el) {
            return;
        }

        const mobile_money_format = this.mobile_subtotal_el.dataset.moneyFormat;
        this.mobile_subtotal_el.setAttribute("data-variant-price", variant.price);

        if (this.product_form.querySelector('[black-friday-block]')) {
            const block = this.product_form.querySelector('[black-friday-block]');
            const cart_total = block.querySelector('[discount-values]').dataset.cartTotal
            const activeBlock = block.querySelector('[variant-id="' + variant.id + '"]');

            if (!activeBlock) {
                this.mobile_subtotal_el.innerHTML = Shopify.formatMoney(variant.price, mobile_money_format);
                return;
            }

            const twenty_off_variant_price = activeBlock.dataset.twentyOffProductPrice;
            const thirty_off_variant_price = activeBlock.dataset.thirtyOffProductPrice;

            if (!twenty_off_variant_price || !thirty_off_variant_price) {
                this.mobile_subtotal_el.innerHTML = Shopify.formatMoney(variant.price, mobile_money_format);
                return;
            }

            let price = twenty_off_variant_price;

            if (block.dataset.thirtyOffOveride === "true") {
                price = thirty_off_variant_price;
            }

            this.mobile_subtotal_el.innerHTML = `<span class="compare">${Shopify.formatMoney(variant.price, mobile_money_format)}</span> ${Shopify.formatMoney(price, mobile_money_format)}`;
        } else {

            if (this.addOnPrice !== null) {
                let new_price = variant.price + parseInt(this.addOnPrice);
                this.mobile_subtotal_el.innerHTML = Shopify.formatMoney(new_price, mobile_money_format);
            } else {
                this.mobile_subtotal_el.innerHTML = Shopify.formatMoney(variant.price, mobile_money_format);
            }
        }
    }

    setSubmitButtonState(availability) {
        const submit = this.add_to_cart;
        const label = this.add_to_cart_label;
        const price = this.add_to_cart_price;

        const mobile_submit = this.mobile_add_to_cart;
        const mobile_label = this.mobile_add_to_cart_label;
        const mobile_price = this.mobile_add_to_cart_price;

        const ADD_TO_CART = this.text_add_to_cart;
        const SOLD_OUT = this.text_sold_out;
        const UNAVAILABLE = this.text_unavailable;

        if (!submit) {
            return;
        }

        if (!mobile_submit) {
            return;
        }

        if (availability === true || availability === "true") {
            submit.value = ADD_TO_CART;
            submit.innerHTML = ADD_TO_CART;
            submit.removeAttribute("disabled");
            label.classList.remove("disabled");
            price.style.display = 'block';

            mobile_submit.value = ADD_TO_CART;
            mobile_submit.innerHTML = ADD_TO_CART;
            mobile_submit.removeAttribute("disabled");
            mobile_label.classList.remove("disabled");
            mobile_price.style.display = 'block';
        } else if (availability === "unavailable") {
            submit.value = UNAVAILABLE;
            submit.innerHTML = UNAVAILABLE;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");
            price.style.display = 'none';

            mobile_submit.value = UNAVAILABLE;
            mobile_submit.innerHTML = UNAVAILABLE;
            mobile_submit.setAttribute("disabled", "");
            mobile_label.classList.add("disabled");
            mobile_price.style.display = 'none';
        } else {
            submit.value = SOLD_OUT;
            submit.innerHTML = SOLD_OUT;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");
            price.style.display = 'none';

            mobile_submit.value = SOLD_OUT;
            mobile_submit.innerHTML = SOLD_OUT;
            mobile_submit.setAttribute("disabled", "");
            mobile_label.classList.add("disabled");
            mobile_price.style.display = 'none';
        }
    }

    setQuantityVisibility(availability) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_wrapper = this.quantity_selector.closest('.quantity-wrapper');
        if (!quantity_wrapper) {
            return;
        }

        if (availability === "unavailable" || availability === false) {
            quantity_wrapper.style.display = "none";
        } else {
            quantity_wrapper.style.display = "flex";
        }
    }

    setQuantityStock(variant) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const max_stock = this.stock_rules[variant.id];
        quantity_input.max = max_stock;
    }

    setQuantityRules(quantity_rule) {
        if (!this.quantity_selector) {
            return;
        }

        if (!quantity_rule) {
            quantity_rule = { min: 1, step: 1 };
        }
    
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }
    
        const quantity_number_el = this.quantity_selector.querySelector('[quantity]');
        if (!quantity_number_el) {
            console.error("Quantity number element not found.");
            return;
        }
    
        if (quantity_rule.min) {
            quantity_input.min = quantity_input.value = quantity_number_el.innerHTML = quantity_rule.min;
        } else {
            quantity_input.min = quantity_input.value = quantity_number_el.innerHTML = 1;
        }
        if (quantity_rule.max) {
            quantity_input.max = quantity_rule.max;
        }
        if (quantity_rule.step) {
            quantity_input.step = quantity_rule.step;
        }
    }    

    checkRadios(selector) {
        const selects = selector.selectors;
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 1) {
            selects.forEach((select) => {
                const select_index = select.index + 1;
                const selected_option_index = select.element.selectedIndex;
                const radio_to_check = this.product_form.querySelector(`.radio-option[data-option="${select_index}"] input[data-index="${selected_option_index}"]`);
                if (radio_to_check) {
                    radio_to_check.checked = true;
                    radio_to_check.setAttribute("checked", true);
                } else {
                    console.log(`Radio button for select ${select_index} not found.`);
                }
            });
        }
    }  

    radiosOnChange() {
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 0) {
            radios.forEach(radio => {
                radio.addEventListener('change', () => {
                    const option_index = radio.closest('.radio-option').dataset.option;
                    const option_value = radio.value;
                    const select = this.product_form.querySelector(`select[data-option='option${option_index}']`);
    
                    if (select) {
                        select.value = option_value;
                        const event = new Event('change');
                        select.dispatchEvent(event);
                    } else {
                        console.error(`Select element for radio ${option_index} not found.`);
                    }

                });
            });
        }
    }

    variantImageChange(variant) {
        if (!this.gallery_slides) {
          return;
        }
        const if_card = this.product_form.getAttribute('data-card');
        if (if_card == "true") {
            return;
        }
        const is_quickview = this.product_form.closest(".quick-view-modal") ? true : false;
        this.gallery_slides.forEach((slide) => {
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;
            if (!slide_id) {
                return;
            }
            const slide_variant_ids = slide_id.split(',');
            if (slide_variant_ids.includes(variant.id.toString())) {
                if (is_quickview) {
                    if (window.gallery_swiper) {
                        window.gallery_swiper.slideTo(slide_index, 500);
                    }
                } else {
                    mainSwiper.slideTo(slide_index,500);
                }
            }
        });
    }

    selectCallback(variant, selector) {
        console.log(variant);
        this.currentVariant = variant; // Add this line to store the current variant
        
        // AVAILABILITY STATES
        const AVAILABILITY_AVAILABLE = true;
        const AVAILABILITY_UNAVAILABLE = "unavailable";
        const AVAILABILITY_SOLD_OUT = "sold_out";

        // SUBMIT BUTTON STATE - Changes submit button text and state based on variant availability
        if (!variant) {
            this.setSubmitButtonState(AVAILABILITY_UNAVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_UNAVAILABLE);
            return;
        }

        if (variant.available) {
            this.setSubmitButtonState(AVAILABILITY_AVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_AVAILABLE);
        } else {
            this.setSubmitButtonState(AVAILABILITY_SOLD_OUT);
            this.setQuantityVisibility(AVAILABILITY_SOLD_OUT);
        }

        // CHECK RADIOS - checks radio buttons based on option select element
        this.checkRadios(selector);
        // QUANTITY RULES IF PRESENT - Adds min and max attributes to quantity input
        this.setQuantityStock(variant);
        // SET PRICE - Sets price based on variant
        this.setQuantityRules(variant.quantity_rule);
        // SET STOCK - Sets max stock attribute to quantity input
        this.setVariantPrice(variant);
        // SET IMAGE - Changes main image based on variant
        this.variantImageChange(variant);
        // SET DISCOUNT VALUES - Sets discount values based on variant
        this.setDiscountValues(variant);
        // Note: Remove the setBlackFridayBlock call since we now handle it via the listener
        this.setAddOns(variant);
    }

    setDiscountValues(variant) {
        let discount_values_el = this.product_form.querySelectorAll("[discount-values]");
        if (!discount_values_el || discount_values_el.length === 0) {
            return;
        }
        discount_values_el.forEach((v) => v.dataset.active = v.id === variant.id.toString() ? "true" : "false");
    }

    // Remove or comment out the old setBlackFridayBlock method
    // setBlackFridayBlock(variant) { ... }

    shopifyOptionSelect() {
        new Shopify.OptionSelectors(this.master_select_prefix + '-' + this.section_id + '-' + this.product_id, {
            product: this.product_json,
            onVariantSelected: this.selectCallback.bind(this),
            enableHistoryState: this.enable_history
        });
    }
}